import smsMessageStore from './store'

export default class SmsModule {
  name = 'smsMessage'
  constructor({ store }) {
    store.registerModule(this.name, smsMessageStore)
  }
}
